module.exports = require("core-js-pure/stable/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/symbol/iterator.js
// module id = 155
// module chunks = 0 1